// Common international dial codes, sorted by country name. Not exhaustive -
// covers the countries most relevant to Zeevogo's candidate base (India,
// Europe, Gulf) plus other major countries. Values are used as the option
// value directly (e.g. "+91"), paired with a plain-number phone_number field.
export const COUNTRY_CODES = [
  { label: 'India (+91)', value: '+91' },
  { label: 'Poland (+48)', value: '+48' },
  { label: 'Romania (+40)', value: '+40' },
  { label: 'Croatia (+385)', value: '+385' },
  { label: 'Germany (+49)', value: '+49' },
  { label: 'Spain (+34)', value: '+34' },
  { label: 'United Kingdom (+44)', value: '+44' },
  { label: 'France (+33)', value: '+33' },
  { label: 'Italy (+39)', value: '+39' },
  { label: 'Netherlands (+31)', value: '+31' },
  { label: 'Portugal (+351)', value: '+351' },
  { label: 'Ireland (+353)', value: '+353' },
  { label: 'Sweden (+46)', value: '+46' },
  { label: 'Norway (+47)', value: '+47' },
  { label: 'Denmark (+45)', value: '+45' },
  { label: 'Finland (+358)', value: '+358' },
  { label: 'Switzerland (+41)', value: '+41' },
  { label: 'Austria (+43)', value: '+43' },
  { label: 'Belgium (+32)', value: '+32' },
  { label: 'Greece (+30)', value: '+30' },
  { label: 'Czechia (+420)', value: '+420' },
  { label: 'Slovakia (+421)', value: '+421' },
  { label: 'Hungary (+36)', value: '+36' },
  { label: 'Bulgaria (+359)', value: '+359' },
  { label: 'United Arab Emirates (+971)', value: '+971' },
  { label: 'Saudi Arabia (+966)', value: '+966' },
  { label: 'Qatar (+974)', value: '+974' },
  { label: 'Kuwait (+965)', value: '+965' },
  { label: 'Oman (+968)', value: '+968' },
  { label: 'Bahrain (+973)', value: '+973' },
  { label: 'Nepal (+977)', value: '+977' },
  { label: 'Bangladesh (+880)', value: '+880' },
  { label: 'Sri Lanka (+94)', value: '+94' },
  { label: 'Pakistan (+92)', value: '+92' },
  { label: 'Philippines (+63)', value: '+63' },
  { label: 'Indonesia (+62)', value: '+62' },
  { label: 'United States / Canada (+1)', value: '+1' },
  { label: 'Australia (+61)', value: '+61' },
  { label: 'New Zealand (+64)', value: '+64' },
  { label: 'Singapore (+65)', value: '+65' },
  { label: 'Malaysia (+60)', value: '+60' },
  { label: 'South Africa (+27)', value: '+27' },
];
